jQuery(document).ready(function($) {
// Sticky Nav
  let sticky_bar_height = 0;
  let linkClicked = false;

  
 const nav = document.querySelector(".collection-list__left-nav");

  // Get offset attribute
  let scrollOffset = 100;

  const links = document.querySelectorAll('.collection-list__nav-content .button');

  // const navTop = document.querySelector(".collection-list__left-nav").getBoundingClientRect().top;
  const navTop = 517;
  updateOnClickStickyNavState(links);

  
  window.onscroll = function () {
    if($("body").width() < 990){
      scrollOffset = 190
    }
    const scrollPos_start = window.scrollY + parseInt(scrollOffset);
    const scrollPos_end = window.scrollY ;

    if (!linkClicked) {
      updateStickyNavState(links, scrollPos_start);
    }

    if($("body").width() < 990){
      if(scrollPos_start > navTop){
        nav.classList.add("fixed")
      }else{
        nav.classList.remove("fixed")
      }
    }



    
  };

  function updateOnClickStickyNavState(links) {
    links.forEach(function (e) {
      var block_id = e.getAttribute('href') == '#' ? '#no-valid-selector' : e.getAttribute('href');

      if (document.querySelector(block_id)) {
        var refElement = document.querySelector(block_id);
        e.onclick = function (evt) {
          // Prevent default anchor click behavior
          evt.preventDefault();
          
          linkClicked = true;

          if($("body").width() < 990 && !$(nav).hasClass("fixed")){
            sticky_bar_height = 100
          }else{
            sticky_bar_height = 50
          }
          
          var section_top = refElement.getBoundingClientRect().top + window.scrollY - sticky_bar_height - scrollOffset;
          // Added a delay to fix scroll bug on first reload page
          setTimeout(function () {
            window.scroll({
              top: section_top,
              behavior: 'smooth',
            });
          }, 100);

          // Reset linkClicked flag after a delay (e.g., 1000ms)
          setTimeout(function () {
            linkClicked = false;
          }, 100);
        };
      }
    });
  }

  function updateStickyNavState(links, scrollPos_start) {
    links.forEach(function (e) {
      const block_id = e.getAttribute('href') == '#' ? '#no-valid-selector' : e.getAttribute('href');
      if (document.querySelector(block_id)) {
        const refElement = document.querySelector(block_id);
        const section_top = refElement.getBoundingClientRect().top + window.scrollY - sticky_bar_height  - 10;
        if (scrollPos_start >= section_top) {
          links.forEach(function (link) {
            if (link !== e) {
              link.classList.remove('active');
            }
          });

          e.classList.add('active');
        }
      }
    });
  }
  
})